import { render, staticRenderFns } from "./PraticaCorrispondenteEstero.vue?vue&type=template&id=0dabbc6e&scoped=true&"
import script from "./PraticaCorrispondenteEstero.vue?vue&type=script&lang=js&"
export * from "./PraticaCorrispondenteEstero.vue?vue&type=script&lang=js&"
import style0 from "./PraticaCorrispondenteEstero.vue?vue&type=style&index=0&id=0dabbc6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dabbc6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dabbc6e')) {
      api.createRecord('0dabbc6e', component.options)
    } else {
      api.reload('0dabbc6e', component.options)
    }
    module.hot.accept("./PraticaCorrispondenteEstero.vue?vue&type=template&id=0dabbc6e&scoped=true&", function () {
      api.rerender('0dabbc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaCorrispondenteEstero.vue"
export default component.exports